import Slideout from "slideout";

const DrawerMenu = {
  instance: null,
  dom: {
    menuElm: document.getElementById("js-drawerMenu"),
    panelElm: document.getElementById("js-drawerMenuPanel"),
    toggleElm: document.querySelectorAll("#js-drawerMenuToggle"),
    closeElm: document.querySelectorAll("#js-drawerMenuPanel, #js-drawerMenu .js-scroll"),
  },
  options: {
    duration: 10,
  },
  init() {
    if(this.dom.menuElm === null) return;
    if(this.dom.panelElm === null) return;
    this.instance = new Slideout({
      panel: this.dom.panelElm,
      menu: this.dom.menuElm,
      duration: this.options.duration
    });
    this.toggle();
    this.close();
  },
  toggle() {
    Array.from(this.dom.toggleElm).map(elm => {
      elm.addEventListener("click", () => {
        this.instance.toggle();
      });
    });
  },
  close() {
    Array.from(this.dom.closeElm).map(elm => {
      elm.addEventListener("click", () => {
        this.instance.close();
      });
    });
  },

  menuClose() {
    this.instance.close();
  },
  menuOpen() {
    this.instance.open();
  }
}

export default DrawerMenu;